import { createEvent } from 'effector';

/** Resets all assistant chat state (messages, session, status). */
export const assistantChatReset = createEvent();
